import React, { useState, useEffect, memo } from 'react';
import { isObjectEmpty } from 'common/utils/helpers';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import Modal from 'components/shared/Modal/Modal';
import { IconLoader } from 'common/IconLoader';
import ActionDevicesTable from 'components/features/ActionDevicesTable/ActionDevicesTable';
import { BulkManageDevicesLists } from 'components/features/ManageDevicesListsModal/ManageDevicesLists';
import { clearSelectedDevicesData } from 'redux/actions';
import { selectDeviceGroups, selectSelectedDeviceGroupName, selectActiveTabName } from 'redux/selectors';
import { useDispatch, useSelector } from 'react-redux';
import './ManageDevicesListsModal.css';

const BulkManageDevicesListsModal = (props) => {
  const { afterModalClose, animateModalClose, closeModal } = props;

  const deviceGroups = useSelector(selectDeviceGroups);
  const selectedDeviceGroupName = useSelector(selectSelectedDeviceGroupName);
  const activeTab = useSelector(selectActiveTabName);

  const createObjectList = () => {
    let objectList = {};
    !isObjectEmpty(deviceGroups) &&
      Object.keys(deviceGroups).forEach((groupName) => {
        objectList[groupName] = false;
      });
    return objectList;
  };

  const [localCheckList, setLocalCheckList] = useState(createObjectList());
  const [localEditModeList, setLocalEditModeList] = useState(createObjectList());
  const [showActionDevicesTable, setShowActionDevicesTable] = useState(false);
  const [localSelectedDevicesList, setLocalSelectedDevicesList] = useState(null);
  const [localSelectedDeviceGroupName, setLocalSelectedDeviceGroupName] = useState(null);
  const [localSelectedDevicesDictionary, setLocalSelectedDevicesDictionary] = useState(null);
  const dispatch = useDispatch();

  let numOfCheckedLists = Object.keys(localCheckList).filter((groupName) => localCheckList[groupName]).length;

  useEffect(() => {
    if (localSelectedDeviceGroupName) {
      let deviceGroupDevices = deviceGroups[localSelectedDeviceGroupName]?.devices;
      let newLocalSelectedDevicesDictionary = {};
      deviceGroupDevices &&
        deviceGroupDevices.forEach((deviceId) => {
          if (!localSelectedDevicesDictionary) {
            newLocalSelectedDevicesDictionary[deviceId] = { checked: true, matched: true };
          } else {
            if (localSelectedDevicesDictionary[deviceId]) {
              newLocalSelectedDevicesDictionary[deviceId] = localSelectedDevicesDictionary[deviceId];
            } else {
              newLocalSelectedDevicesDictionary[deviceId] = { checked: true, matched: true };
            }
          }
        });
      setLocalSelectedDevicesDictionary(newLocalSelectedDevicesDictionary);
    }
    if (!isObjectEmpty(localSelectedDevicesList)) {
      setShowActionDevicesTable(true);
    } else {
      setShowActionDevicesTable(false);
    }
  }, [localSelectedDevicesList, showActionDevicesTable, localSelectedDeviceGroupName, deviceGroups]);

  return (
    <Modal
      close={afterModalClose} //note that this only runs if you close the modal using the "closing" prop
      animate={animateModalClose}
      animateX={false}
      global
      closing={closeModal}
      noPadding
      height={numOfCheckedLists > 1 ? 719 : 696}
      width={780}
    >
      {!showActionDevicesTable ? (
        <BulkManageDevicesLists
          activeTab={activeTab}
          numOfCheckedLists={numOfCheckedLists}
          deviceGroups={deviceGroups}
          selectedDeviceGroupName={selectedDeviceGroupName}
          localSelectedDevicesList={localSelectedDevicesList}
          localCheckList={localCheckList}
          localEditModeList={localEditModeList}
          setLocalEditModeList={setLocalEditModeList}
          setLocalCheckList={setLocalCheckList}
          setLocalSelectedDevicesList={setLocalSelectedDevicesList}
          setLocalSelectedDeviceGroupName={setLocalSelectedDeviceGroupName}
          setLocalSelectedDevicesDictionary={setLocalSelectedDevicesDictionary}
        />
      ) : (
        <div className="BulkManageDevicesListsModal">
          <div className="BulkManageDevicesListsModal_HeaderDiv">
            <div className="BulkManageDevicesListsModal_HeaderDiv_ReturnButton">
              <SvgAF
                img={IconLoader.icon_back_doc}
                hover={IconLoader.icon_back_doc_hover}
                onClick={() => {
                  setShowActionDevicesTable(false);
                  setLocalSelectedDevicesList(null);
                  dispatch(clearSelectedDevicesData(activeTab));
                }}
              />
            </div>
            <div
              className="BulkManageDevicesListsModal_HeaderDiv_Title"
              data-tip={localSelectedDeviceGroupName ? localSelectedDeviceGroupName : 'All devices'}
            >
              {localSelectedDeviceGroupName ? localSelectedDeviceGroupName : 'All devices'}
            </div>
          </div>
          <ActionDevicesTable
            deviceGroups={deviceGroups}
            localDeviceGroupName={localSelectedDeviceGroupName}
            width={'auto'}
            hasCheckBox={false}
            hasRemoveButtons={true}
            localSelectedDevicesDictionary={localSelectedDevicesDictionary}
            setLocalSelectedDevicesDictionary={setLocalSelectedDevicesDictionary}
            localSelectedDevicesList={localSelectedDevicesList}
            deviceIdList={localSelectedDevicesList}
          />
        </div>
      )}
    </Modal>
  );
};

export default memo(BulkManageDevicesListsModal);
